/**
 * 配置文件
 */
export default {
  /**
   * storage 前缀
   */
  storagePre: 'LLSC',
  /**
   * 使用Mock模式 [true | false]
   */
  useMock: false,
  /**
   * store缓存时间
   * @Unit minute
   */
  cacheTime: 15,
}
